import Axios from "../utils/http-request";
import { getRequestConfiguration } from "../utils/headerHelper";
import { JobIdProps, PostJobPropsType } from "../interface/job_board";
import { AxiosErrorResponse } from "../interface/api_request";

interface FormFields {
  code: string;
  token: string;
}

export const apiPostJob = async (fieldValues: PostJobPropsType) => {
  const formData = new URLSearchParams();

  // Append all form fields to FormData
  Object.entries(fieldValues).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });
  try {
    const uri = `/jobs/post-job`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    return await Axios.post(uri, formData, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiGetFacilityJobs = async (filter: string, page: string) => {
  const cfg = await getRequestConfiguration({
    "Content-Type": "application/x-www-form-urlencoded",
  });
  try {
    const uri = `/jobs/facility?page=${page}&${filter}`;
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetActiveJobs = async () => {
  try {
    const uri = `/jobs/medic`;
    return await Axios.get(uri);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetJobId = async (data: JobIdProps) => {
  try {
    const uri = `/jobs/job/${data?.jobId}`;
    return await Axios.get(uri);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiUpdateJobStatus = async (data: {
  status: string;
  jobId: string;
}) => {
  const formData = new URLSearchParams();
  try {
    const uri = `/jobs/update-status/${data.jobId}`;
    formData.append("status", data?.status);
    const cfg = getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.put(uri, formData.toString(), cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiUpdateJob = async (data: {
  jobId: string;
  fieldValues: Record<string, any>;
}) => {
  try {
    const uri = `/jobs/job/${data.jobId}`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/json",
    });
    return await Axios.put(uri, data.fieldValues, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

// Updated API function
export const apiOutSourceJob = async (data: {
  job_id: string;
  positions_needed: number;
  urgency: "low" | "medium" | "high" | "critical";
  deadline?: string; // ISO 8601 date string
  special_requirements?: string;
  budget_range?: {
    min?: number;
    max?: number;
  };
}) => {
  try {
    const uri = `/outsourced-staffing/facility/request`; // Update this to match your actual route

    const requestBody = {
      job_id: data.job_id,
      positions_needed: data.positions_needed,
      urgency: data.urgency,
      ...(data.deadline && { deadline: data.deadline }),
      ...(data.special_requirements && {
        special_requirements: data.special_requirements,
      }),
      ...(data.budget_range && { budget_range: data.budget_range }),
    };

    const cfg = getRequestConfiguration({
      "Content-Type": "application/json",
    });

    return await Axios.post(uri, requestBody, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiPostJobWithOutsourcing = async (data: any) => {
  try {
    const uri = `/jobs/post-with-outsourcing`;

    return await Axios.post(uri, data);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};
// Job Stats
export const apiGetJobBoardStats = async () => {
  try {
    const uri = `/jobs/stats`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};
